import React, { useEffect, useState } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext.js';
import { db } from '../../firebase.js';
import NewsList from '../../views/admin_sections/news/NewsList';
import NewsDetail from './NewsDetail';
import { useLocation } from 'react-router-dom';
import '../../styles/AdminNews.css';

const Noticias = () => {
  const { currentUser } = useAuth();
  const [news, setNews] = useState([]);
  const [, setLoading] = useState(true);
  const [, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (!currentUser) return;
    const q = query(collection(db, 'news'), where('published', '==', true), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(q, (snap) => {
      try {
        const items = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        // Debug logs removed: snapshot processed silently
        setNews(items);
        setLoading(false);
        setError(null);
      } catch (e) {
        console.error('[Noticias] error procesando snapshot:', e);
        setError(e.message || String(e));
        setLoading(false);
      }
    }, (err) => {
      console.error('Error leyendo noticias para usuario:', err);
      setError(err.message || String(err));
      setLoading(false);
    });
    return () => unsub();
  }, [currentUser]);

  // if path includes an id like /dashboard/news/:id then show detail
  const parts = location.pathname.split('/').filter(Boolean);
  const idx = parts.indexOf('news');
  const idInPath = (idx >= 0 && parts.length > idx + 1) ? parts[idx + 1] : null;

  return (
    <div className="admin-news-section">
      <header className="admin-news-header">
        <h2>Anuncios y Noticias</h2>
      </header>
      {news.length === 0 ? (
        <div className="admin-news-empty">No hay noticias disponibles.</div>
      ) : (
        idInPath ? (
          <NewsDetail newsList={news} />
        ) : (
          // Mostrar todas las noticias publicadas en la página de Noticias del usuario.
          // La elección "No volver a mostrar" solo afecta al popup, no al listado.
          <NewsList news={news} />
        )
      )}
    </div>
  );
};

export default Noticias;
